const cfg = 'resizable=yes,scrollbars=yes';

module.exports = (billingOrderId, text, configs = cfg) => {
	if (navigator && navigator.userAgent.match(/iPhone|iPad|iPod|Mac/i)) {
		document.location.href = `https://oplaty.ria.com/auto/order/${billingOrderId}`;
	} else {
		window.open(`https://oplaty.ria.com/auto/order/${billingOrderId}`, text, configs);
	}
};
